<div class="s09-card">
  <div class="s09-list-head">
    <div style="display:flex;align-items:center;gap:10px">
      <h2>Workflow List</h2>
      <span class="s09-count">{{ rows.length }}</span>
    </div>
    <div class="s09-tools">
      <div class="s09-search">
        <input placeholder="Search by..." [(ngModel)]="search" (ngModelChange)="onSearch()" />
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--s09-muted)" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4.3-4.3"></path></svg>
      </div>
      <select class="s09-filter" [ngModel]="filterTrigger" (ngModelChange)="setFilter($event)">
        <option value="">Filter By</option>
        <option value="Status Change">Status Change</option>
        <option value="Event">Event</option>
        <option value="Schedule">Schedule</option>
        <option value="Manual">Manual</option>
        <option value="Threshold">Threshold</option>
        <option value="Absence">Absence</option>
      </select>
      <button type="button" class="s09-btn-create" (click)="create.emit()">+ Create New Workflow</button>
    </div>
  </div>

  <div class="s09-cols">
    <span *ngFor="let c of cols">{{ c }}</span>
  </div>

  <div *ngIf="loading" class="s09-empty">Loading workflows…</div>
  <div *ngIf="!loading && !rows.length" class="s09-empty">
    <strong>No workflows yet</strong>
    <span>Nothing is loaded from the API. Create a workflow to open the designer and add steps.</span>
    <button type="button" class="s09-btn-create" (click)="create.emit()">+ Create New Workflow</button>
  </div>

  <ng-container *ngFor="let g of groups">
    <div class="s09-group-head">
      <strong>{{ g.label }}</strong>
      <span>{{ g.sub }}</span>
    </div>
    <div class="s09-row" *ngFor="let w of g.rows" (click)="openWorkflow.emit(w.def)">
      <div style="display:flex;align-items:center;gap:10px;min-width:0;padding-right:10px">
        <span class="s09-code">{{ w.code }}</span>
        <div class="s09-name">
          <strong>{{ w.shortName }}</strong>
          <span class="s09-code-chips" *ngIf="w.codeChips.length; else noStatusCodes">
            <span class="s09-code-chip" *ngFor="let c of w.codeChips">{{ c }}</span>
          </span>
          <ng-template #noStatusCodes><small>—</small></ng-template>
        </div>
      </div>
      <div><span class="s09-pill">{{ w.trigger }}</span></div>
      <div>
        <span class="s09-status" [style.border-color]="w.statusBorder" [style.color]="w.statusFg">{{ w.status }}</span>
      </div>
      <span style="font-size:13px">{{ w.version }}</span>
      <span style="font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:12px">{{ w.owner }}</span>
      <span style="font-size:13px">{{ w.lastRun }}</span>
      <span style="font-size:13px">{{ w.instances }}</span>
      <span style="font-size:13px;font-weight:500" [style.color]="w.failFg">{{ w.failure }}</span>
      <div class="s09-actions" (click)="$event.stopPropagation()">
        <button type="button" class="s09-icon-btn" title="Open" (click)="openWorkflow.emit(w.def)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
            stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>
        </button>
        <button type="button" class="s09-icon-btn" title="Clone" (click)="cloneWorkflow.emit(w.def)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
            stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
        </button>
        <button type="button" class="s09-icon-btn" title="Logs" (click)="showLogs.emit(w.def)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
            stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path></svg>
        </button>
        <button type="button" class="s09-icon-btn danger" title="Delete" (click)="deleteWorkflow.emit(w.def)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
            stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14"></path></svg>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="s09-footer">
    <span>{{ rows.length }} of {{ definitions.length }}</span>
    <span>Page 1 of 1</span>
  </div>
</div>
